export default __webpack_public_path__ + "static/media/rewards.918ddb85.png";